import authService from '@/users/services/auth-service'
import { Component, Vue, Ref } from 'vue-property-decorator'

@Component
export default class Login extends Vue {

  @Ref()
  private validator!: ValidationObserver

}
